import React from 'react'

function Row(props) {
  return (
    <div className="row">
    {
      props.cols.map((col, index) => {
        return (
          <div className={col.className || "col"} key={index} >
            {col.value}
          </div>
        )
      })
    }
    </div>
  )
}

export default Row